// import DatePickerLocale from 'rmc-date-picker/lib/locale/zh_CN';

export default {
  errorMessage: 'å½åæ¶é´ä¸è®¾å®æå¤§ææå°æ¥ææ ¼å¼ä¸ä¸è´',
  curTMorethanMax: 'å½åæ¶é´å¤§äºè®¾å®æå¤§æ¥æ',
  curTLessthanMin: 'å½åæ¶é´å°äºè®¾å®ææå°æ¥æ',
  okText: 'ç¡®å®',
  dismissText: 'åæ¶',
  extra: 'è¯·éæ©',
  // DatePickerLocale,
  year: 'å¹´',
  month: 'æ',
  day: 'æ¥',
  hour: 'æ¶',
  minute: 'å',
  am: 'ä¸å',
  pm: 'ä¸å'
};
